import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { analytics } from "@silvertours/front-entities";
import React from "react";
import Link from "next/link";
import { useLogin } from "../../LoginForm";
import { List, NavigationItem, StyledLink } from "./LoggedInActions.styles";
var LoggedInActions = function(param) {
    var translations = param.translations;
    var isLoggedIn = useLogin().isLoggedIn;
    var linkTranslations = translations.accountLinks;
    var accountLinks = [
        {
            text: linkTranslations.myBookings.text,
            href: linkTranslations.myBookings.href,
            onClick: function() {
                analytics.gtm.trackMyBookings({
                    isLoggedIn: isLoggedIn
                });
            }
        },
        {
            text: linkTranslations.myData.text,
            href: linkTranslations.myData.href,
            onClick: function() {
                analytics.gtm.trackMyData({
                    isLoggedIn: isLoggedIn
                });
            }
        },
        {
            text: linkTranslations.myPayment.text,
            href: linkTranslations.myPayment.href,
            onClick: function() {
                analytics.gtm.trackMyPayment({
                    isLoggedIn: isLoggedIn
                });
            }
        },
        {
            text: linkTranslations.logout.text,
            href: linkTranslations.logout.href,
            onClick: function() {
                analytics.gtm.trackLogout();
            }
        }, 
    ];
    return /*#__PURE__*/ _jsx(List, {
        role: "menu",
        "aria-label": translations.account,
        children: accountLinks.map(function(link, index) {
            return /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    index === accountLinks.length - 1 && /*#__PURE__*/ _jsx("hr", {}),
                    /*#__PURE__*/ _jsx(NavigationItem, {
                        role: "presentation",
                        children: /*#__PURE__*/ _jsx(Link, {
                            passHref: true,
                            href: link.href,
                            children: /*#__PURE__*/ _jsx(StyledLink, {
                                text: link.text,
                                href: link.href,
                                role: "menuitem",
                                onClick: link.onClick
                            })
                        })
                    })
                ]
            }, "nav-".concat(link.href));
        })
    });
};
export { LoggedInActions };
